export const developmentOperators = [
  'dev',
  'development',
  'local',
  'danielsan',
  'northumberland_zoo',
] as const;

const stagingOperators = [
  'test-operator',
  'zoo',
  'aquarium',
  'heritage',
  'museum',
  'football-club',
  'theme-park',
  'test-arena',
  'temporary-operator',
  'september',
  'north-it'
] as const;

const productionOperators = [
  'a-bwak',
  'alnwick-castle',
  'amo',
  'awcp',
  'aycliffe-aquarium',
  'aycliffe-castle',
  'aycliffe-cathedral',
  'aycliffe-fc',
  'aycliffe-gallery',
  'aycliffe-holiday-park',
  'aycliffe-museum',
  'aycliffe-rentals',
  'aycliffe-stadium',
  'aycliffe-theme-park',
  'aycliffe-zoo',
  'coastfest',
  'ctijf',
  'destination-durham',
  'homes-by-carlton',
  'host-and-stay',
  'jersey-zoo',
  'jfwp',
  'keeperfest',
  'knowsley',
  'ldz',
  'lhp',
  'longleat',
  'northumberland-zoo',
  'rafc',
  'tanfield-railway',
  'tap',
  'tmf',
  'wild-discovery',
  'wof',
  'wpt',
  'wwp',
  'wwt',
] as const;

export const allOperators = [...developmentOperators, ...productionOperators, ...stagingOperators] as const;